"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const duration_comparison_1 = require("./duration-comparison");
const number_comparison_1 = require("./number-comparison");
const inversify_1 = require("inversify");
const boolean_expression_1 = require("./boolean-expression");
const SystemNamespace = 'system';
let SystemDslModule = class SystemDslModule {
    constructor() {
        this.ns = SystemNamespace;
        this.durationComparison = new duration_comparison_1.DurationComparison();
        this.numberComparison = new number_comparison_1.NumberComparison();
        this.booleanExpression = new boolean_expression_1.BooleanExpression();
    }
    get functions() {
        return [
            ...this.durationComparison.functions(),
            ...this.numberComparison.functions(),
            ...this.booleanExpression.functions()
        ];
    }
    get implementations() {
        return [
            ...this.durationComparison.implementations(),
            ...this.numberComparison.implementations(),
            ...this.booleanExpression.implementations()
        ];
    }
};
SystemDslModule = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [])
], SystemDslModule);
exports.SystemDslModule = SystemDslModule;
//# sourceMappingURL=system-dsl-module.js.map